import { Indicator } from 'mint-ui';
import 'mint-ui/lib/indicator/style.css';
import './style.less';

export default {
  show(text, type = 'fading-circle') {
    Indicator.open({
      text,
      spinnerType: type,
    });
  },
  close() {
    Indicator.close();
  },
};
